import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import dayjs from "dayjs";
import { create } from "zustand";
import { PassCategory } from "../api/membership";
const usePassStore = create((set)=>{
    return {
        isPassInfoModal: false,
        selectedPass: null,
        purchasePass: null,
        passPayMethod: "card",
        redirectPath: null,
        setRedirectPath: (url)=>set({
                redirectPath: url
            }),
        setPassPayMethod: (payMethod)=>set({
                passPayMethod: payMethod
            }),
        setPurchasePass: (pass)=>set({
                purchasePass: pass
            }),
        closePassInfoModal: ()=>{
            set({
                isPassInfoModal: false
            });
            set({
                selectedPass: null
            });
        },
        openPassInfoModal: (pass)=>{
            var _pass_userPassInfo;
            // pass를 맵핑
            const { passInfo  } = pass;
            const descriptionList = passInfo.description ? passInfo.description.split("\n") : [];
            const expiredAt = ()=>{
                if (!pass.userPassInfo) return null;
                return dayjs(pass.userPassInfo.expiredAt).format("YYYY.MM.DD HH:mm:ss");
            };
            const startedAt = ()=>{
                if (!pass.userPassInfo) return null;
                return dayjs(pass.userPassInfo.startedAt).format("YYYY.MM.DD");
            };
            var _passInfo_isUnlimited, _ref;
            const mappedPass = {
                remainDay: pass.userPassInfo ? pass.userPassInfo.remainDay : null,
                expiredAt: expiredAt(),
                startedAt: startedAt(),
                remainCount: pass.userPassInfo ? pass.userPassInfo.remainCount : null,
                remainAmount: pass.userPassInfo ? pass.userPassInfo.remainAmount : null,
                isNoCountLimit: passInfo.category === PassCategory.FreePass || passInfo.category === PassCategory.Subscription || passInfo.category === PassCategory.Solvookplus,
                descriptionList,
                // isUnlimited는 /passes에서 진입시, 이용권 구매 페이지에서 전달되는 이용권관련 값.
                // userPassInfo는 mypage/passes에서 전달되는 내가 가지고 있는 이용권 정보.
                isExpertUnLimited: (_ref = (_passInfo_isUnlimited = passInfo.isUnlimited) !== null && _passInfo_isUnlimited !== void 0 ? _passInfo_isUnlimited : (_pass_userPassInfo = pass.userPassInfo) === null || _pass_userPassInfo === void 0 ? void 0 : _pass_userPassInfo.isUnLimited) !== null && _ref !== void 0 ? _ref : false
            };
            set({
                selectedPass: {
                    ...passInfo,
                    ...mappedPass
                }
            });
            set({
                isPassInfoModal: true
            });
            mixpanelEvent("Product Detail Popup Viewed", {
                "Product Categories": passInfo.category,
                "Product ID": passInfo.id,
                "Product Title": passInfo.title,
                "Product Price": passInfo.price
            });
        }
    };
});
export default usePassStore;
